import { Box, Button, styled, TextField } from "@mui/material";
import { brighthiveTheme } from "../../../../../theme/theme";

export const ActionsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  gap: 8px;
  margin-right: 1.3rem;
`;

export const ButtonAttachment = styled(Box)`
  position: relative;
  line-height: 0;
  width: 40px;
  height: 40px;
  pointer-events: none;
  cursor: default;

  .MuiSvgIcon-root {
    width: 19px;
    height: 19px;
    opacity: 0.5;
  }

  label {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${brighthiveTheme.palette.primary.lighter};
    }
  }

  input {
    opacity: 0;
    clip: rect(0, 0, 0, 0);
    position: absolute;
    width: 1px;
    height: 1px;
  }
`;

export const ButtonSubmit = styled(Button)`
  padding: 0;
  min-width: 1px;
  line-height: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .MuiSvgIcon-root {
    width: 19px;
    height: 19px;
  }
`;

export const EditorWrapper = styled(Box)`
  position: relative;
  border-radius: 4px;
  background-color: ${brighthiveTheme.palette.settings.lighter};
  margin-top: 8px;
`;

export const FormWrapper = styled(Box)`
  position: relative;
`;

export const FormField = styled(TextField)`
  width: 100%;

  > .MuiInputBase-formControl {
    padding: 0;
    font-size: 14px;
    line-height: 1.2;
  }

  > div.MuiInputBase-formControl {
    padding: 1.3rem 1.3rem;
    padding-right: 4rem;
  }

  fieldset {
    border-color: transparent !important;
  }

  .MuiOutlinedInput-input {
    padding-right: 0.5rem;
  }

  .MuiOutlinedInput-input:focus {
    box-shadow: none;
  }
`;
